import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Area,
  LabelProps,
  TooltipProps,
  TooltipPayload,
} from "recharts";
import { COLOR_BED_VENT_NON_COVID } from "../../../GlobalColors";

interface HospitalizationChartProps {
  data: App.HospitalCensusRecord[];
  name: string;
}

export default function HospitalCensus(props: HospitalizationChartProps) {
  const { data } = props;

  function customizedLabel(props: LabelProps) {
    const { x, y, value } = props;
    return (
      <text
        className="dataLabel"
        x={x}
        y={y}
        dy={-10}
        fontSize={10}
        textAnchor="middle"
      >
        {value}
      </text>
    );
  }

  function resourceTooltip({
    payload,
    label,
    active,
  }: {
    payload?: ReadonlyArray<TooltipPayload> | undefined;
    label?: string | number | undefined;
    active?: boolean | undefined;
  }) {
    if (!active! || !payload || payload.length !== 2) return null;

    const total = (payload[1].value as number) + (payload[0].value as number);

    return (
      <div className="chart-tooltip bg-light p-2">
        <p className="font-weight-bold mb-2">{`Date: ${label}`}</p>
        <p className="font-weight-bold mb-0">{`Total COVID19 Patients: ${total}`}</p>
        <p className="mb-1">
          <span style={{ color: "#002e6c", opacity: ".5" }}>{"\u25A0"} </span>
          {`Confirmed COVID19 Patients: ${payload[1].value}`}
        </p>
        <p className="mb-1">
          <span style={{ color: COLOR_BED_VENT_NON_COVID, opacity: ".5" }}>
            {"\u25A0"}{" "}
          </span>
          {`COVID19 PUI Patients: ${payload[0].value}`}
        </p>
      </div>
    );
  }

  return (
    <ResponsiveContainer height={400}>
      <AreaChart
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="date" />
        <YAxis
          domain={[0, (dataMax) => Math.round(dataMax * 1.05)]}
          // tickFormatter={(value) => value}
        />
        <Tooltip
          content={(props: TooltipProps) => resourceTooltip(props)}
          // formatter={(value) => value}
        />
        <Legend
          payload={[
            {
              id: "pts",
              value: "Total Covid Patients",
              type: "line",
              color: "#002e6c",
            },
          ]}
        />
        <Area
          name="COVID19 PUI Patients"
          dot={false}
          strokeWidth="2"
          stackId="a"
          type="monotone"
          dataKey="pui"
          fill={COLOR_BED_VENT_NON_COVID}
          stroke={COLOR_BED_VENT_NON_COVID}
        />
        <Area
          name="Confirmed COVID19 Patients"
          dot={false}
          strokeWidth="2"
          stackId="a"
          type="monotone"
          dataKey="pts"
          stroke="#002e6c"
          label={(props: LabelProps) => customizedLabel(props)}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
